import { isTouchScreen } from '../../../styles'
import type { Tokens } from '../../../theming/types'
import type { RadioButtonProps } from '..'

const radioButtonSize = '20px'

export default (config: {
  props: Pick<RadioButtonProps, 'description' | 'error' | 'hideLabel'>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  return {
    default: {
      wrap: {
        minHeight: tokens.ctaSizeSm,
      },

      input: {
        insetBlockStart: '10px',
        insetInlineStart: '2px',
        height: radioButtonSize,
        width: radioButtonSize,
      },

      label: {
        minHeight: tokens.ctaSizeSm,
        paddingInlineStart: tokens.spacingGap50,

        paddingBlockStart: tokens.spacingGap100,
        paddingBlockEnd: tokens.spacingGap100,

        [isTouchScreen]: {
          paddingBlockStart: tokens.spacingGap150,
          paddingBlockEnd: tokens.spacingGap150,
        },

        '&::before': {
          content: '""',
          height: '24px',
          width: props.hideLabel ? '8px' : 0,
        },
      },

      labelText: {
        ...tokens.fontBodyS,
        minHeight: '24px',
        paddingBlockStart: '2px',
        marginInlineStart: tokens.spacingGap100,
      },

      description: {
        marginBlockStart: '-8px', // Gives a little bit more click area to the radio button (label)
        marginInlineStart: tokens.spacingGap400,
      },

      error: {
        marginBlockStart: props.description ? tokens.spacingGap50 : 0,
        marginInlineStart: tokens.spacingGap400,

        [isTouchScreen]: {
          marginBlockStart: props.description ? tokens.spacingGap50 : 0,
        },
      },

      focusStyles: {
        insetBlockStart: '10px',
        insetInlineStart: '2px',
      },

      radioButtonHover: {
        borderRadius: '50%',
        boxShadow: `0 0 0 6px ${tokens.formControlHighlightBgColorDefault}`,
        position: 'absolute',
        insetBlockStart: '-2px',
        insetInlineStart: '-2px',
        height: radioButtonSize,
        width: radioButtonSize,
        opacity: 0,
      },

      radioButtonBorder: {
        borderWidth: '2px',
        boxShadow: `none`,
        height: radioButtonSize,
        width: radioButtonSize,
      },

      radioButtonFill: {
        border: `4px solid`,
        marginInlineStart: tokens.spacingGap50,
      },
    },

    motionVariants: {
      radioButtonHover: {
        hoverWhenChecked: {
          opacity: 1,
          transition: { duration: 0.1 },
        },
        hoverWhenUnchecked: {
          opacity: 1,
          transition: { duration: 0.1 },
        },
        tapWhenChecked: {
          opacity: 0,
          transition: { duration: 0 },
        },
        tapWhenUnchecked: {
          opacity: 0,
          transition: { duration: 0 },
        },
      },

      radioButtonFill: {
        checked: {
          borderColor: tokens.formBgColorSelected,
          opacity: 1,
          scale: 1,
          transition: { duration: 0.15 },
        },
        tapWhenChecked: {
          opacity: 1,
          transition: { duration: 0.15 },
        },
      },
    },
  } as const
}
